import ColorKeys from '../../constants/ColorKeys';

// Set color to active hero's tile
export function setActiveHeroTileColor() {
  const { posX, posY } = this.activeHero;
  const tile = this.tiles[posX][posY];
  tile.setTint(ColorKeys.Khaki);
}

// Clear color for active hero's tile
export function clearActiveHeroTileColor() {
  const { posX, posY } = this.activeHero;
  this.tiles[posX][posY].clearTint();
}

// Set color to available moving tiles
export function setAvailableMoveTilesColor() {
  for (let i = 0; i < this.availableMoveTiles.length; i++) {
    const { posX, posY } = this.availableMoveTiles[i];
    this.tiles[posX][posY].setTint(ColorKeys.Blue);
  }
}

// Clear color for all available moving tiles
export function clearAvailableMoveTilesColor() {
  for (let i = 0; i < this.availableMoveTiles.length; i++) {
    const { posX, posY } = this.availableMoveTiles[i];
    this.tiles[posX][posY].clearTint();
  }
}

// Set color to available attack tiles
export function setAvailableAttackTilesColor() {
  for (let i = 0; i < this.availableAttackTiles.length; i++) {
    const { posX, posY } = this.availableAttackTiles[i];
    this.tiles[posX][posY].setTint(ColorKeys.Red);
  }
}

// Clear color for all available attack tiles
export function clearAvailableAttackTilesColor() {
  for (let i = 0; i < this.availableAttackTiles.length; i++) {
    const { posX, posY } = this.availableAttackTiles[i];
    this.tiles[posX][posY].clearTint();
  }
}

// Clear color for all tiles
export function clearAllTilesColor(withActiveHero = true) {
  if (withActiveHero) {
    clearActiveHeroTileColor.call(this);
  }
  clearAvailableMoveTilesColor.call(this);
  clearAvailableAttackTilesColor.call(this);
}
